export function extendedfooterRender() {
    return `<div class="messaging-footer-extended" style="${this.__$objToStyleMap(this.extendStyle)}">
            ${this.config.extendedFooterItems.map(function (item) {
                return `<topbar-element type="${item.type}"
                            imgname="${item.imgName || ''}"
                            content="${item.content || ''}"
                            imgsrc="${item.imgSrc || ''}"
                            text="${item.text || ''}"
                            subtext="${item.subText}"
                            mode="${item.mode}"
                            extended="true"
                            style="${this.__$objToStyleMap(this.extendItemStyle)}"
                            hiddenstates="${item.hiddenStates && item.hiddenStates.join(',') || ''}"
                            hiddendevices="${item.hiddenDeviceTypes && item.hiddenDeviceTypes.join(',') || ''}"
                            audioonimgname="${item.audioOnImgName}"
                            audiooffimgname="${item.audioOffImgName}"
                            ld--elist="click"
                            ld-on-click="onIconClick">
                        </topbar-element>` }.bind(this)).join('')}
            </div>`;
}